var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200.000000pt",
    height: "200.000000pt",
    viewBox: "0 0 200.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81 1982 c-19 -9 -44 -30 -55 -45 -20 -27 -21 -43 -24 -355 -3 -375 -2 -378 79 -420 43 -22 48 -23 359 -20 349 3 355 4 396 72 17 28 19 58 22 346 3 311 2 316 -20 359 -41 80 -47 81 -408 81 -280 0 -319 -2 -349 -18z m629 -407 l0 -285 -285 0 -285 0 0 285 0 285 285 0 285 0 0 -285z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220 1982 c-22 -11 -44 -35 -57 -62 -22 -43 -23 -53 -23 -349 0 -287 1 -307 21 -347 15 -31 32 -48 63 -63 40 -20 60 -21 347 -21 296 0 306 1 349 23 79 40 80 46 80 407 0 347 -2 359 -63 404 -27 20 -43 21 -355 24 -302 2 -330 1 -362 -16z m640 -407 l0 -285 -285 0 -285 0 0 285 0 285 285 0 285 0 0 -285z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 838 c-80 -42 -81 -45 -78 -420 4 -451 -30 -418 428 -418 361 0 367 1 408 80 21 43 22 53 22 349 0 287 -1 307 -21 347 -15 31 -32 48 -63 63 -40 20 -60 21 -347 21 -296 0 -306 -1 -349 -22z m630 -413 l0 -285 -285 0 -285 0 0 285 0 285 285 0 285 0 0 -285z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1223 839 c-30 -15 -48 -33 -62 -63 -20 -40 -21 -60 -21 -347 0 -296 1 -306 23 -349 41 -80 44 -81 419 -78 451 4 418 -30 418 428 0 361 -1 367 -80 408 -43 21 -53 22 -350 22 -289 0 -307 -1 -347 -21z m637 -414 l0 -285 -285 0 -285 0 0 285 0 285 285 0 285 0 0 -285z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.5b9b75bf131153c018ec168fca85a9bf.svg";
export { ForwardRef as ReactComponent };